/*
 * @Author: your name
 * @Date: 2021-09-16 11:31:05
 * @LastEditTime: 2025-02-08 09:52:26
 * @LastEditors: luodongming
 * @Description: In User Settings Edit
 * @FilePath: \yelink-ecm-portal-web\src\main.js
 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: function(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop)
    },
    configurable: true,
    writable: true
  })
}

import Cookies from 'js-cookie'
import i18n from './lang' // internationalization
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router, { resetRouter } from './router'
import { copyText } from '@/utils/clipboard'
import { refreshKeycloakToken } from '@/utils/keycloak-token'

import './icons' // icon
import './utils/error-log' // error log

import * as filters from './filters' // global filters
import { hasPermission, hasNoPermission, hasAnyPermission } from './utils/permissionDirect'
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import './assets/iconfont/iconfont.css'
import VueClipboard from 'vue-clipboard2'
import { cloudMecToken } from '@/api/ecm-portal'
import db from '@/utils/localstorage'
import { menuUser } from '@/api/user'
import * as vega from 'vega'
import * as vegaLite from 'vega-lite'
import vegaEmbed from 'vega-embed'

window.vega = vega
window.vegaLite = vegaLite
window.vegaEmbed = vegaEmbed
Vue.use(VueClipboard)
const Plugins = [
  hasPermission,
  hasNoPermission,
  hasAnyPermission
]
Plugins.map((plugin) => {
  Vue.use(plugin)
})
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
Vue.prototype.hdCopy = (text) => {
  copyText(text)
  document.getElementById('app').click()
}

let isJingzhiLogin = false

/**
 * 适配 MEC 在精致 APP 端以在线小程序的方式打开时免登录，需要获取精致登录后的 Token
 * 适配从第三方访问 ，增加一个  type 参数: http://yelink.yelinksaas.com/?type=third_party_guest
 */
if (window.location.search.includes('third_party_guest') || localStorage.getItem('Token') !== null) {
  const token = 'guest_view'
  cloudMecToken(token).then(res => {
    if (res.data.access_token) {
      isJingzhiLogin = true
      db.save('ACCESS_TOKEN', res.data.access_token)
      db.save('Fresh-Token', res.data.refresh_token)
      db.save('Token-Type', res.data.token_type)

      menuUser().then((res) => {
        const permissions = res.permissions
        store.commit('account/setPermissions', permissions)
        store.commit('account/setRoutes', res.routes)
        resetRouter(res.routes)
      })
      document.title = '工业应用市场'
    }
  }).catch((e) => {
    isJingzhiLogin = false
  }).finally(() => {
    // 非精致可信环境，加载 KeyCloak 验证
    if (!isJingzhiLogin) {
      loadKeyCloak()
    }
    new Vue({
      el: '#app',
      router,
      store,
      i18n,
      render: h => h(App)
    })
  })
} else {
  loadKeyCloak()
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
  })
}

function loadKeyCloak() {
  require('./permission')
  Vue.use(VueKeyCloak, {
    init: {
      onLoad: process.env.VUE_APP_KEYCLOAK_OPTIONS_ONLOAD,
      checkLoginIframe: false
    },
    config: {
      realm: process.env.VUE_APP_KEYCLOAK_OPTIONS_REALM,
      url: process.env.VUE_APP_KEYCLOAK_OPTIONS_URL,
      clientId: process.env.VUE_APP_KEYCLOAK_OPTIONS_CLIENTID
    },
    onReady: kc => {
      console.log('onReady')
      if (kc.token) {
        store.dispatch('account/keycloakLogin', kc.token).then(() => {
          return store.dispatch('account/getKeycloakInfo', null)
        })
        //  Token Refresh
        setInterval(() => {
          refreshKeycloakToken(70).then(({ refreshed, token }) => {
            if (refreshed) {
              // Keycloak 内部 token 更新后同步 Store 和 localStorage，后续请求才能使用新 token。
              store.dispatch('account/keycloakLogin', token)
              console.log('Token refreshed ' + refreshed)
            }
          }).catch(() => {
            console.error('Failed to refresh token')
          })
        }, 6000)
      }
    }
  })
}
